import { FETCHED_ONE, FETCHED_ALL, TURNED_OFF, DELETED } from './actions'

export default function reducer(state = null, action = {}) {
  const { payload = {}, type } = action
  const { result, entities } = payload
  switch (type) {
    case FETCHED_ONE:
      return {
        ...state,
        alarm: entities.alarms[result],
      }
    case FETCHED_ALL:
      return {
        ...state,
        entities: {
          ...entities.alarms,
        },
        result: [...result],
      }
    case TURNED_OFF:
      return null
    case DELETED:
      return {
        ...state,
        alarm: null,
      }
    default:
      return state
  }
}
